import * as React from 'react';

function Profile(props) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 20 20"
      className="prefix__w-4 prefix__h-4"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
        clipRule="evenodd"
      />
    </svg>
  );
}

const MemoProfile = React.memo(Profile);
export default MemoProfile;
